// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['ja_JP']  = {
  "name": "ja_JP",
  "day": {
    "abbrev": [
      "日",
      "月",
      "火",
      "水",
      "木",
      "金",
      "土"
    ],
    "full": [
      "日曜日",
      "月曜日",
      "火曜日",
      "水曜日",
      "木曜日",
      "金曜日",
      "土曜日"
    ]
  },
  "month": {
    "abbrev": [
      " 1月",
      " 2月",
      " 3月",
      " 4月",
      " 5月",
      " 6月",
      " 7月",
      " 8月",
      " 9月",
      "10月",
      "11月",
      "12月"
    ],
    "full": [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月"
    ]
  },
  "meridiem": [
    "午前",
    "午後"
  ],
  "date": "%Y年%m月%d日",
  "time24": "%H時%M分%S秒",
  "dateTime": "%Y年%m月%d日 %H時%M分%S秒",
  "time12": "%p%I時%M分%S秒",
  "full": "%Y年 %b %e日 %A %H:%M:%S %Z"
}

